import { useId } from 'react'
import { cx } from '../utils/cx'
import type { ConsentSwitchProps } from './types'
import './ConsentSwitch.css'

/** Interruptor de consentimiento (bundle B3): toggle de 44 × 26 con título y explicación; siempre revocable. */
export function ConsentSwitch({ checked, onChange, title, description, disabled, id, name, className }: ConsentSwitchProps) {
  const uid = useId()
  const inputId = id ?? `hp-consent-${uid}`
  const descId = `${inputId}-desc`
  return (
    <label htmlFor={inputId} className={cx('hp-consent', checked && 'hp-consent--on', disabled && 'hp-consent--disabled', className)}>
      <input
        id={inputId}
        name={name}
        type="checkbox"
        role="switch"
        aria-checked={checked}
        aria-describedby={description ? descId : undefined}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="hp-consent__input"
      />
      <span className="hp-consent__track" aria-hidden="true">
        <span className="hp-consent__thumb" />
      </span>
      <span className="hp-consent__text">
        <span className="hp-consent__title">{title}</span>
        {description && (
          <span id={descId} className="hp-consent__desc">
            {description}
          </span>
        )}
      </span>
    </label>
  )
}
